module.exports = __webpack_public_path__ + "img/logo-cn-white.0a90c0f.png";